import Vue from "vue";
import Vuex from "vuex";

import app from "./modules/app";
import activities from "./modules/activities";
import favorites from "./modules/favorites";
import audits from "./modules/audits";
import audit from "./modules/audit";
import standards from "./modules/standards";
import categories from "./modules/categories";
import users from "./modules/users";
import templates from "./modules/templates";
import configuration from "./modules/configuration";
import autocompletes from "./modules/autocompletes";

Vue.use(Vuex);

export const api = {
  namespace: null,
  getters: {},
  mutations: {},
  state: {}
};

export default new Vuex.Store({
  // plugins: [vuexLocalStorage.plugin],
  mutations: {},
  actions: {
    unloadState({ commit }) {
      console.log("UNLOAD STATE");

      commit("activities/resetState");
      commit("app/resetState");
      commit("audits/resetState");
      commit("categories/resetState");
      commit("standards/resetState");
      commit("templates/resetState");
      commit("users/resetState");
      commit("autocompletes/CLEAR_AUTO_COMPLETES_DATA");
      commit("configuration/resetState");
      // TODO: Unload configuration!
    }
  },
  getters: {},
  modules: {
    app,
    users,
    audits,
    audit,
    standards,
    activities,
    categories,
    templates,
    configuration,
    autocompletes,
    favorites
  },
  strict: process.env.NODE_ENV !== "production"
});
